<main>
<div class="container">
  <app-header></app-header>
  <app-liss-curve></app-liss-curve>
  <router-outlet></router-outlet>
</div>
</main>
<app-footer></app-footer>
